import { Text } from "@radix-ui/themes";
import { useAppSelector } from "@/app/appStore";
import { useLiveDelay } from "@/shared/hooks/useLiveDelay";

export function LiveDelay() {
  const isLive = useAppSelector((state) => state.player.videoStream.isLive);
  const cameraId = useAppSelector((state) => state.player.videoStream.cameraId);
  const { liveDelay } = useLiveDelay();

  if (!isLive || !cameraId) {
    return null;
  }

  return (
    <Text size="1" color="gray" className="tabular-nums">
      Live delay: {liveDelay}
    </Text>
  );
}
